module.exports = __webpack_public_path__ + "static/media/maf-14.101f4e39.png";